import axios from '@/plugins/axios'

export function getBlogById(token, id) {
	return axios({
		url: 'blog',
		method: 'GET',
		headers: {
			Authorization: token,
		},
		params: {
			id
		}
	})
}

export function checkBlogPassword(blogPasswordForm) {
	return axios({
		url: 'checkBlogPassword',
		method: 'POST',
		data: {
			...blogPasswordForm
		}
	})
}

export function getSearchBlogResultList(query, pageNum = 1, showProgress = true) {
	return axios({
		url: 'searchBlogs',
		method: 'GET',
		showProgress,
		params: pageNum === 1 ? {query} : {query, pageNum}
	})
}
